import React from 'react';

const Section1BasicInfo = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">1. Basic Information</h4>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Full Name <span className="text-danger">*</span></label>
                <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Gender <span className="text-danger">*</span></label>
                <select name="gender" value={formData.gender} onChange={handleChange} className="form-select" required>
                    <option value="">Select...</option>
                    <option>Male</option>
                    <option>Female</option>
                </select>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Date of Birth <span className="text-danger">*</span></label>
                <input type="date" name="dob" value={formData.dob} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Age <span className="text-danger">*</span></label>
                <input type="number" name="age" value={formData.age} onChange={handleChange} className="form-control" required />
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Height (e.g., 5' 8")</label>
                <input type="text" name="height" value={formData.height} onChange={handleChange} className="form-control" />
            </div>
             <div className="col-md-6 mb-3">
                <label className="form-label">Marital Status <span className="text-danger">*</span></label>
                <select name="maritalStatus" value={formData.maritalStatus} onChange={handleChange} className="form-select" required>
                    <option>Never Married</option>
                    <option>Divorced</option>
                    <option>Widowed</option>
                    <option>Separated</option>
                </select>
            </div>
        </div>
    </div>
);

export default Section1BasicInfo;